import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    setUser(userInfo);

    if(userInfo){
      

      if(userInfo.role==='Teacher'){
        navigate('/admin')
      }else if(userInfo.role==='Student'){
        navigate('/student')
      };
    }
  },[navigate]);
  return(
    <AuthContext.Provider value={{user,setUser}} > 
      {children} 
    </AuthContext.Provider>
  )
}

export const AuthState = () =>{
 return useContext(AuthContext);
}


export default AuthProvider;